import { FC } from "react";
import { Text } from "@otrium/atoms";
import { Box } from "@otrium/core";
import { StyledFilters } from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/CategoriesTree/CategoriesTree.styled";
import { MultiselectHitType } from "src/types/Algolia";
import { Checkbox } from "src/atoms/Checkbox";
import { CategoriesCheckboxTree } from "./CategoriesCheckboxTree";

interface Props {
  items?: MultiselectHitType[];
  refine: (value: MultiselectHitType) => void;
  isSelected: (hit: MultiselectHitType) => boolean;
  shouldShowChildren: boolean;
  currentSlug?: string;
}

const MultiselectCategories: FC<Props> = ({
  items,
  refine,
  isSelected,
  shouldShowChildren,
  currentSlug,
}) => {
  return (
    <StyledFilters>
      <Box as="ul" data-testid="desktop-brand-category-list">
        {items?.map((c) => {
          const splittedItem = c.label?.split("||");
          const name = splittedItem[1];
          const itemSlug = splittedItem[2] || "";
          const isLocalShouldShowChildren =
            !currentSlug || currentSlug === itemSlug || shouldShowChildren;
          return (
            <Box as="li" key={c.label} pb={2}>
              <Checkbox checked={isSelected(c)} onChange={() => refine(c)}>
                <Text fontWeight={600}>{name}</Text>
              </Checkbox>
              {c.items && isLocalShouldShowChildren && (
                <CategoriesCheckboxTree
                  items={c.items}
                  refine={refine}
                  isSelected={isSelected}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </StyledFilters>
  );
};

export default MultiselectCategories;
